import {setCookie, getCookie, returnDay, getData, postData} from "../../sources/js/functions/helpers";

const calculator = document.querySelector('.calculator');
const promoOpenBtn = document.querySelector('[data-promo-open]');
const promoApplyBtn = document.querySelector('[data-promo-submit]');
const promoEditBtn = document.querySelector('[data-promo-edit]');
const tabs = document.querySelectorAll('input[name="tabs"]');

if (calculator) loadPriceList();

if (tabs) {
    tabs.forEach(tab => {
        tab.addEventListener('change', (e) => {
            const value = e.target.value

            if (value === 'new') {
                document.querySelector('.button_take_loan').style.display = 'flex';
                document.querySelector('.button_get_money').style.display = 'none';
            } else {
                document.querySelector('.button_take_loan').style.display = 'none';
                document.querySelector('.button_get_money').style.display = 'flex';
            }
        })
    })
}

if (promoApplyBtn) {
    promoApplyBtn.addEventListener('click', () => checkPromoCode())
}

if (promoOpenBtn) {
    promoOpenBtn.addEventListener('click', () => {
        document.querySelector('[data-promo-form]').classList.toggle('active');
    })
}

if (promoEditBtn) {
    promoEditBtn.addEventListener('click', () => {
        document.querySelector('.calculator__promo_apply').style.display = 'none';
        document.querySelector('.calculator__promo_code').style.display = 'block';
    })
}

async function getProduct() {
    try {
        const product = await getData(API_ACTIVE_PRODUCT)
        return product[0].id
    } catch (err) {
        console.log(err);
    }
}

async function loadPriceList() {
    try {
        const productId = await getProduct()
        const apiPath = `${API_PATH}/${productId}/price_list`

        const code = getCookie('loan_promocode')
        const userId = getCookie('__LK_2user_id')
        const access_token = getCookie('access_token')
        const path = (code && code !== undefined) ? `${apiPath}?promo_code=${code}&user_id=${userId}` : apiPath
        const options = (userId && access_token) ? {headers: {'X-AUTH-TOKEN': access_token}} : {}
        const price = await getData(path, options)

        init_calculator(price);
    } catch (err) {
        const productId = await getProduct()
        const apiPath = `${API_PATH}/${productId}/price_list`
        const price = await getData(apiPath)

        init_calculator(price);

        setCookie('loan_promocode', '')
        document.querySelector('[data-promo-code]').style.display = 'block';
        document.querySelector('[data-promo-apply]').style.display = 'none';
        document.querySelector('[data-regular-price]').style.display = 'none';

        console.log(err);
    }
}

async function checkPromoCode() {
    try {
        const productId = await getProduct()
        const apiPath = `${API_PATH}/${productId}/price_list`

        const code = document.querySelector('[data-promo-value]').value
        const userId = getCookie('__LK_2user_id')
        const access_token = getCookie('access_token')
        const path = `${apiPath}?promo_code=${code}&user_id=${userId}`
        const options = (userId && access_token) ? {headers: {'X-AUTH-TOKEN': access_token}} : {}
        const price = await getData(path, options)

        if (price && !price.message) {
            const term = getCookie('loan_term')
            const sum = getCookie('loan_sum')
            const discount = price[term][sum]['discount']['settlement_amount'] || 0
            const loginUser = getCookie('access_token') && getCookie('__LK_2user_id')
            const repeatUser = loginUser && getCookie('repeat_user')

            if (discount) {
                setCookie('loan_promocode', code)
                document.location.reload(true)
            } else {
                document.querySelector('[data-promo-value]').classList.add('error');

                if (loginUser) {
                    document.querySelector('[data-promo-error]').classList.add('active');
                    document.querySelector('[data-promo-notice]').classList.remove('active');
                } else {
                    document.querySelector('[data-promo-error]').classList.remove('active');
                    document.querySelector('[data-promo-notice]').classList.add('active');
                }
            }
        } else {
            document.querySelector('[data-promo-value]').classList.add('error');
            document.querySelector('[data-promo-error]').classList.add('active');
            document.querySelector('[data-promo-notice]').classList.remove('active');
        }
    } catch (err) {
        console.log(err);
    }
}

function init_calculator(loan_price) {
    let domain = document.location.hostname;

    let dateCookie = new Date(new Date().getTime() + 2592000000);

    let state = {};

    const loan_amount = document.getElementById('loan_amount');
    const payment_date = document.getElementById('payment_date');
    const settlement_amount = document.getElementById('settlement_amount');
    const settlement_amount_free = document.getElementById('settlement_amount_free');
    const discount_amount = document.getElementById('discount_amount');
    const summa = document.getElementById('summa');

    let array_term = Object.keys(loan_price);
    let array_loan = Object.keys(loan_price[array_term[0]]);
    let min = parseInt(array_loan[0], 10);
    let max = parseInt(array_loan[array_loan.length - 1], 10);
    let step = parseInt(array_loan[1], 10) - parseInt(array_loan[0], 10);
    let cookieName = 'loan_sum';
    let value = getCookie(cookieName);

    if (loan_price.message) {
        min = parseInt(summa.dataset.defaultMin);
        max = parseInt(summa.dataset.defaultMax);
        step = 1000;
    }

    if (value === false || value > max || value < min) {
        value = summa.dataset.defaultAmount ? summa.dataset.defaultAmount : (min * 3);
        document.cookie = cookieName + "=" + value + "; path=/; domain=" + domain + "; expires=" + dateCookie.toUTCString();
    }

    state[cookieName] = value;

    rangeSlider(
        document.getElementById('slider-summa'),
        document.getElementById('summa'),
        document.getElementById('summa_min'),
        document.getElementById('summa_max'),
        {
            min: min,
            max: max,
            step: step,
            value: value,
            cookieName: cookieName
        }
    );

    min = parseInt(array_term[0], 10);
    max = parseInt(array_term[array_term.length - 1], 10);

    document.querySelector('.calculator__loader').style.display = 'none';

    function rangeSlider(range, input, spanMin, spanMax, values) {
        range.setAttribute('min', values.min);
        range.setAttribute('max', values.max);
        range.setAttribute('step', values.step);
        range.setAttribute('value', values.value);

        spanMin.innerHTML = new Intl.NumberFormat('ru').format(values.min);
        spanMax.innerHTML = new Intl.NumberFormat('ru').format(values.max);

        updateValue(values.value);

        range.addEventListener('input', function () {
            updateValue(range.value);
        });

        input.addEventListener('input', () => {
            input.value = input.value.replace(/[^0-9^\s]/, '');
        });

        input.addEventListener('change', () => {
            let input_value = input.value.replace(/\s/g, '');
            if (input_value == null) {
                input_value = values.min;
            } else {
                input_value = parseInt(input_value, 10);
            }
            updateValue(input_value);
        });

        function updateValue(value) {

            range.value = value;
            value = range.value;

            state[values.cookieName] = value;

            const percentage = (100 * (value - values.min)) / (values.max - values.min);
            const thumbWidth = 25;
            let pxThumb = (thumbWidth / 100) * percentage;
            let setting = thumbWidth / 2 - pxThumb;

            range.style.background = `linear-gradient(90deg, #9C8FE6 calc(${percentage}% + ${setting}px), #E6E1FF calc(${percentage}% + ${setting}px))`;

            input.value = new Intl.NumberFormat('ru').format(value);

            document.cookie = values.cookieName + "=" + value + "; path=/; domain=" + domain + "; expires=" + dateCookie.toUTCString();

            cookieName = 'loan_term';
            value = getCookie(cookieName);

            if (!value || value > max || value < min) {
                value = summa.dataset.defaultTerm ? summa.dataset.defaultTerm : 5;
                document.cookie = cookieName + "=" + value + "; path=/; domain=" + domain + "; expires=" + dateCookie.toUTCString();
            }

            state[cookieName] = value;

            if (state['loan_term'] && state['loan_sum']) {
                if (loan_amount) {
                    loan_amount.innerHTML = new Intl.NumberFormat('ru').format(loan_price[state['loan_term']][state['loan_sum']].principal);
                }

                if (payment_date) {
                    payment_date.innerHTML = returnDay(state['loan_term']);
                }

                if (settlement_amount) {
                    settlement_amount.innerHTML = new Intl.NumberFormat('ru').format(loan_price[state['loan_term']][state['loan_sum']].settlement_amount);
                }

                if (discount_amount) {
                    const regularPrice = loan_price[state['loan_term']][state['loan_sum']].settlement_amount;
                    const discount = loan_price[state['loan_term']][state['loan_sum']]['discount']['settlement_amount'];

                    discount_amount.innerHTML = discount ?
                        new Intl.NumberFormat('ru').format(regularPrice - discount) :
                        new Intl.NumberFormat('ru').format(regularPrice);
                }

                if (settlement_amount_free) {
                    settlement_amount_free.innerHTML = new Intl.NumberFormat('ru').format(loan_price[state['loan_term']][state['loan_sum']].principal);
                }
            }
        }
    }
}

(function () {
    const form = document.querySelector('[data-form-subscribe]');

    if (form) {
        const input = form.querySelector('#phone_number');

        const clearErrorMsg = () => {
            const messages = form.querySelectorAll('.form__message-text')
            if (messages) messages.forEach(msg => msg.style.display = 'none')

            form.classList.remove('error')
        }

        const setUserError = (msg) => {
            form.classList.add('error')
            form.querySelector('.form__message-user').innerHTML = msg
            form.querySelector('.form__message-user').style.display = 'block'
        }

        const getFingerprint = () => {
            const fingerPrint = window.fingerPrint

            if (fingerPrint.visitorId) {
                fingerPrint.visitor_id = fingerPrint.visitorId
                delete fingerPrint.visitorId
            }

            return fingerPrint
        }

        const checkForm = (elem) => {
            clearErrorMsg()

            form.classList.add('error')

            let valid = false
            if (!elem) {
                form.querySelector('.form__message-empty').style.display = 'block'
            } else if (elem.length !== 9) {
                form.querySelector('.form__message-length').style.display = 'block'
            } else {
                valid = true
                form.classList.remove('error')
            }

            return valid
        }

        if (input) {
            input.addEventListener('input', (e) => {
                clearErrorMsg()

                const value = e.target.value.replace(/\D+/g, "")

                if (value[0] !== '7') {
                    form.classList.add('error')
                    form.querySelector('.form__message-digit').style.display = 'block'

                    e.target.value = ''
                } else {
                    let number = ''

                    for (let i = 0; i < value.length; i++) {
                        switch (i) {
                            case 3:
                                number += ' ';
                                break;
                            case 6:
                                number += ' ';
                                break;
                            default:
                                break;
                        }

                        number += value[i];
                    }

                    e.target.value = number;
                }
            });
        }

        form.addEventListener('submit', (e) => {
            e.preventDefault()

            const obj = {}
            const formData = new FormData(form)

            obj.target_url = getCookie('target_url')

            for (let entity of formData.entries()) {
                if (entity[0] === 'phone_number' && entity[1] !== '') {
                    obj.username = entity[1].match(/\d+/g).join('')
                }
            }

            const validate = checkForm(obj.username)
            if (!validate) return false

            const fingerprint = getFingerprint()
            const fingerprintData = {
                'fingerprint_js': {
                    'visitor_id': fingerprint.visitor_id
                },
                'phone_number': obj.username
            }

            postData(API_RECAPTCHA, fingerprintData).then((response) => {
                if (!response.ok && !window.recaptchaSuccess) {
                    form.querySelector('.form__col_recaptcha').style.display = 'block'
                    return false
                } else {
                    postData(API_ONE_TIME_PASSWORD, {'phone_number': obj.username}).then((response) => {
                        if (response.ok) {
                            window.location.href = `${window.location.origin}/${ICL_LANGUAGE_CODE === 'en' ? 'en/' : ''}user/login?phone_number=${obj.username}`
                        } else {
                            if (response.data.message === 'User not found.') {
                                const modal = document.querySelector('[data-modal-calc]')

                                if (modal) {
                                    modal.classList.add('modal_active')

                                    const modalForm = modal.querySelector('form')

                                    if (modalForm) {
                                        let phoneNumber = obj.username.match(new RegExp(`.{1,3}`, 'g'))
                                        phoneNumber = '+94 ' + phoneNumber.join(' ')

                                        modalForm.querySelector('[data-modal-phone-number]').innerHTML = phoneNumber

                                        modalForm.addEventListener('submit', (e) => {
                                            e.preventDefault()

                                            postData(API_USERS, obj).then((response) => {
                                                if (response.ok && response.data.user) {
                                                    setCookie('__LK_2user_id', response.data.user.id)
                                                    setCookie('access_token', response.data.token)
                                                    setCookie('refresh_token', response.data.refresh_token)

                                                    setTimeout(() => {
                                                        window.location.href = `${window.location.origin}/${ICL_LANGUAGE_CODE === 'en' ? 'en/' : ''}user/registration`
                                                    }, 100)
                                                } else {
                                                    console.log(response)
                                                }
                                            })
                                        })
                                    }
                                }
                            } else {
                                clearErrorMsg()
                                setUserError(response.message)
                            }
                        }
                    })

                    form.reset()
                }
            })
        });
    }
})();
